import config from '~/config';
import Price from '~/libs/Price/Price';

export default class ProductSourcePrice {
	type: string;

	price: Price | null;

	priority: number;

	constructor(type: string, price: Price | null, priority: number) {
		this.type = type;
		this.price = price;
		this.priority = priority;
	}

	humanFormatType(): string {
		const type = config.product.priceTypes.find((type) => type.code === this.type);
		return type !== undefined ? type.label : this.type;
	}

	humanCondensedFormatType(): string {
		const type = config.product.priceTypes.find((type) => type.code === this.type);
		return type && type.condensedLabel ? type.condensedLabel : this.type;
	}
}
